module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.15518f50.eot";